import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { adminSettingsApi } from "./Reducer/adminSetting";
import { adminSupportApi } from "./Reducer/adminSupport";
import { authApi } from "./Reducer/auth";
import { contactApi } from "./Reducer/contact";
import { dashboardApi } from "./Reducer/dashboard";
import { FaqsApi } from "./Reducer/faqs";
import { fileApi } from "./Reducer/file";
import { roomsApi } from "./Reducer/rooms";
import { tagsApi } from "./Reducer/tags";
import { usersApi } from "./Reducer/users";
import userReducer from "./slices/userSlice";
import { aiSubscriptionPlanApi } from "./Reducer/aiSubscriptionPlans";
import { paymentsApi } from "./Reducer/payments";
import { aiUsageApi } from "./Reducer/aiUsage";

// Define the persist configuration
const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['user'],
};

// Create a persisted reducer for the user slice
const persistedUserReducer = persistReducer(persistConfig, userReducer);

// Create the Redux store with the persisted reducer for the user slice
export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [FaqsApi.reducerPath]: FaqsApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [adminSettingsApi.reducerPath]: adminSettingsApi.reducer,
    [adminSupportApi.reducerPath]: adminSupportApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [roomsApi.reducerPath]: roomsApi.reducer,
    [tagsApi.reducerPath]: tagsApi.reducer,
    [aiSubscriptionPlanApi.reducerPath]: aiSubscriptionPlanApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [aiUsageApi.reducerPath]: aiUsageApi.reducer,
    user: persistedUserReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE', 'persist/REGISTER'],
      },
    }).concat(
      FaqsApi.middleware,
      contactApi.middleware,
      adminSettingsApi.middleware,
      adminSupportApi.middleware,
      usersApi.middleware,
      dashboardApi.middleware,  
      authApi.middleware, 
      fileApi.middleware,
      roomsApi.middleware,
      tagsApi.middleware,
      aiSubscriptionPlanApi.middleware, 
      paymentsApi.middleware,
      aiUsageApi.middleware,
    ),
});

// Initialize Redux Persist
export const persistor = persistStore(store);

// Setup listeners
setupListeners(store.dispatch);